import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import * as styles from './styles'

const propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired
}

export default function PricingComparisonTable({ columns, rows }) {
  return (
    <styles.Table>
      <styles.TableBody>
        <styles.AspectRow>
          {_.map(columns, (c, i) => (
            <styles.TableCell key={i}>{c}</styles.TableCell>
          ))}
        </styles.AspectRow>
        {_.map(rows, (row, id) => (
          <styles.AspectRow key={'row'.concat(id.toString())}>
            {_.map(_.map(row.split(','), w => w.trim()), (cell, i) => (
              <styles.TableCell key={i}>{cell}</styles.TableCell>
            ))}
          </styles.AspectRow>
        ))}
      </styles.TableBody>
    </styles.Table>
  )
}

PricingComparisonTable.propTypes = propTypes
